
export class CollectedResourceBaseCountersModel {
  shouldBeCollected: number;
  totalCollected: number;
  notCollectedDetails: { [key: string]: string };
  perAccessModeCollected: { [key: string]: number };
}
